import { interpolate } from '../../../global';
import { ILanguageResources, ITranslationModule } from '../../../interfaces';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scriptsV6.v6config.v6-quote-item.UpdateV6DefaultsModal.';
  public static readonly bodyText = `${Id.prefix}bodyText`;
}

export class LangV6UpdateDefaultsModal {
  private constructor() {}

  public static bodyText(params: {
    attributeTypeDisplayLabel: string;
    attributeDisplayLabel: string;
    attributeDisplayValue: string;
  }): string {
    return interpolate(Id.bodyText, params);
  }
}

export class V6UpdateDefaultsModalModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.bodyText,
      `You have modified the **{{attributeTypeDisplayLabel}}**

+ **{{attributeDisplayLabel}}** 
++ **{{attributeDisplayValue}}**

## Press "Update" to make this the new Default value for {{glossary 'frame:plural'}} added to the  {{glossary 'quote'}}? 

**Note:** To update existing {{glossary 'frame:plural'}} values, go to the Defaults page and update existing values.`,
      'Body text for update V6 defaults modal, with attribute and value interpolation'
    );
  }
}
